import React from "react"
import { StoreProvider } from "./components/ui/Context"
import Routes from "./components/Router"
import "./taiwind.css"
import "./Base.css"

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <Routes />
        <div id="modal-root"></div>
      </StoreProvider>
    </div>
  )
}

export default App
